module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title","address":"Address","post":"Post","country":"Country","vat":"VAT number"},"sl":{"title":"Naziv","address":"Naslov","post":"Pošta","country":"Država","vat":"Davčna številka"}}')
  delete Component.options._Ctor
}
